import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      padding: '0 26px',
    },
    toggleLabel: {
      fontSize: '16px',
      color: '#808080',
      opacity: '57%',
      fontWeight: '500',
      margin: '7px',
      cursor: 'pointer',
      letterSpacing: '0px',
    },
    selected: {
      color: '#F37321',
      opacity: '100%',
    },
    highlight: {
      height: '10px',
      width: '135%',
      background: '#F37321',
      border: '1.5px solid #F37321',
      borderRadius: '100px',
      //   marginTop: '6px',
      //   position: 'relative',
      //   top: '5px',
    },
    wrapper: {
      // width: '142px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'column',
      height: '30px',
    },
  }),
  { index: 1 },
)

export { useStyles }
